import React from "react";
import Loadable from "react-loadable";
import CircularProgress from "../../../components/CircularProgress";

const AsyncIndex = Loadable({
  loader: () => import("./ReminderComponent"),
  loading: () => <CircularProgress className="gx-loader-400" />,
});

export default AsyncIndex;
